import $ from 'jquery';
import { Functions } from '../../../helpers';
import { Component } from '../../../component';

export class Toggle extends Component {
    /**
     * constructor
     */
    constructor( context ) {
        super( context );

        this.namespace = 'c-toggle';
        this.classes = {
            element: `${ this.namespace }`,
            isActive: 'is-active',
            isHidden: 'is-hidden',
            // isTransitionIn: 'is-transitioning-in',
            // isTransitionOut: 'is-transitioning-out',
        };
    }

    /**
     * setup
     */
    setup() {
        // Bind events
        $( `.js-${ this.classes.element }` ).on( 'click', this.toggle.bind( this ) );
    }

    /**
     * toggle
     * @param evt
     */
    toggle( evt ) {
        if ( evt ) {
            evt.preventDefault();
        }

        this.hide();
        this.show( evt );
    }

    /**
     * show
     * @param evt
     */
    show( evt ) {
        const $el = $( evt.currentTarget );
        const targetId = $el.data( 'toggle-target' ).replace( '#', '' );
        const $target = $( `#${ targetId }` );

        $el.addClass( this.classes.isActive );
        $el.attr( 'aria-expanded', true );

        if ( $target.length ) {
            // $target.removeClass( this.classes.isTransitionOut ).addClass( this.classes.isTransitionIn );

            // setTimeout( () => {
            //     $target.addClass( this.classes.isActive );
            // }, 600 );

            /*$target.animate( {
                opacity: 1,
            }, {
                duration: 300,
            } )
            .promise()
            .done( () => {
                $target.removeClass( this.classes.isHidden ).addClass( this.classes.isActive );
            } );*/

            // $target.on( 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', () => {
            //
            // } );

            // $target.fadeIn();

            $target.removeClass( this.classes.isHidden ).addClass( this.classes.isActive );
        }
    }

    /**
     * hide
     */
    hide() {
        $( `.js-${ this.classes.element }` ).each( ( index, el ) => {
            const $el = $( el );
            const targetId = $el.data( 'toggle-target' ).replace( '#', '' );
            const $target = $( `#${ targetId }` );

            $el.removeClass( this.classes.isActive );
            $el.attr( 'aria-expanded', false );

            if ( $target.length ) {
                // $target.removeClass( this.classes.isTransitionIn ).addClass( this.classes.isTransitionOut );

                // setTimeout( () => {
                //     $target.removeClass( this.classes.isActive );
                // }, 600 );

                /*$target.animate( {
                    opacity: 0,
                }, {
                    duration: 300,
                } )
                .promise()
                .done( () => {
                    $target.removeClass( this.classes.isActive ).addClass( this.classes.isHidden );
                } );*/

                // $target.fadeOut();

                $target.removeClass( this.classes.isActive ).addClass( this.classes.isHidden );
            }
        } );
    }
}
